<template>
  <v-app>
    <div style="position: fixed; height: 100vh; background-color: #222">
      <v-img src="@/assets/login.jpg" width="100vw" cover />
    </div>
    <v-container id="fundo" class="p-0 fill-height">
      <v-row class="layout-login-row">
        <v-col cols="12" :style="$vuetify.breakpoint.xs ? 'padding: 4px' : ''">
          <v-row class="fill-height" align="center" justify="center">
            <v-col cols="12" sm="8" md="5" lg="8" style="padding: 0px">
              <v-container
                :style="$vuetify.breakpoint.xs ? 'padding: 4px' : ''"
              >
                <v-card color="white" style="padding: 12px">
                  <v-container class="pb-2">
                    <v-row
                      class="layout-logos-login fill-height px-4 height"
                      align="center"
                      justify="center"
                    >
                      <v-img
                        class="logo-form-login educampo"
                        src="img/milk-plan.png"
                        height="120px"
                        contain
                      />
                    </v-row>
                  </v-container>
                  <div v-if="!loader">
                    <v-form
                      id="form"
                      ref="form"
                      v-model="valid"
                      @submit.prevent="solicitarDemo"
                    >
                      <v-container class="p-4">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.Nome"
                              label="Razão Social *"
                              :rules="requiredRules"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.cnpj"
                              v-mask="maskCpf"
                              label="CNPJ *"
                              :rules="requiredRules"
                              return-masked-value
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="Endereço *"
                              :rules="requiredRules"
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="form.estado"
                              label="Estado"
                              name="estado_agroindustria"
                              :items="estado"
                              item-text="nome"
                              item-value="id"
                              @change="changeCidade"
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="form.cidade"
                              label="Cidade"
                              :items="cidade"
                              item-text="nome"
                              item-value="id"
                              :disabled="disableCidade"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.email"
                              label="Email *"
                              :rules="emailRules"
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="form.password"
                              light
                              prepend-inner-icon="mdi-key"
                              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                              :rules="[rules.required]"
                              :type="show1 ? 'text' : 'password'"
                              name="password"
                              label="Senha *"
                              counter
                              @click:append="show1 = !show1"
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="form.passwordConfirme"
                              light
                              prepend-inner-icon="mdi-key"
                              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                              :rules="[rules.required]"
                              :type="show2 ? 'text' : 'password'"
                              name="passwordConfirme"
                              label="Confirme sua Senha *"
                              counter
                              @click:append="show2 = !show2"
                            />
                          </v-col>
                        </v-row>
                        <v-row justify="center" class="pt-2">
                          <v-btn color="success" class="mr-4" type="submit">
                            Solicitar Demonstração
                          </v-btn>
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                  <v-container v-else class="pa-6">
                    <v-row justify="space-around">
                      <v-progress-circular
                        :size="100"
                        :width="7"
                        color="primary"
                        :indeterminate="true"
                      />
                    </v-row>
                  </v-container>
                </v-card>
              </v-container>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar"
        multi-line
        top
        :timeout="3500"
        color="error"
      >
        {{ message }}
        <v-btn dark text @click="snackbar = false"> Fechar </v-btn>
      </v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
export default {
  props: {
    backgroundImage: {
      type: String,
      default: 'static/img/login.jpg',
    },
  },
  data() {
    return {
      message: '',
      loader: false,
      valid: null,
      rules: {
        required: value => !!value || 'Obrigatório.',
        emailMatch: () => 'O email ou a senha estão incorretos',
      },
      salvando: false,
      loading: true,
      show1: false,
      show2: false,
      maskCpf: '##.###.###/####-##',
      maskTelFixo: '(##) #####-####',
      emailRules: [v => /.+@.+/.test(v) || 'E-mail invalido'],
      requiredRules: [v => !!v || '* Obrigatório'],
      disableCidade: '',
      btnNome: !this.$route.params.codAgro ? 'Salvar' : 'Salvar Alterações',
      form: {
        nome: '',
        cnpj: '',
        endereco: '',
        estado: '',
        cidade: '',
        email: '',
        telefone: '',
        password: '',
        passwordConfirme: '',
      },
      estado: [{nome: 'Carregando', id: 0}],
      cidade: [{nome: 'Carregando', id: 0}],
      snackbar: false,
    }
  },
  created() {
    this.loadNewForm()
  },
  methods: {
    loadNewForm() {
      this.loading = false
      this.loadEstado()
    },
    solicitarDemo() {
      this.$refs.form.validate()
      if (!this.valid) {
        this.Swal.fire(
          'Atenção',
          'Preencha os itens obrigatórios sinalizados com ("*").',
          'warning',
        )
      } else {
        this.salvando = true
        this.alert = false
        this.api
          .post('/agroindustria/createAgroindustriaDemonstracao', this.form)
          .then(response => {
            this.salvando = false
            if (response.data.error) {
              let erros = ''
              response.data.message.forEach(el => {
                erros += el + '<br/>'
              })
              this.Swal.fire({
                title: 'Corrija os erros abaixo:',
                icon: 'warning',
                html: erros,
              })
            } else {
              this.Swal.fire(
                'Sucesso',
                'Solicitação Enviada com Sucesso',
                'success',
              )
              this.$router.push({name: 'Login'})
            }
          })
          .catch(error => {
            this.salvando = false
            this.Swal.fire({
              title: 'Atenção:',
              icon: 'warning',
              html: error,
            })
          })
      }
    },
    changeCidade() {
      this.loadCidade(this.form.estado)
      // console.log(this.company.estado)
    },
    loadCidade(CodEstado) {
      this.api('/cidade', {
        params: {
          CodEstado: CodEstado,
        },
      })
        .then(response => {
          this.cidade = response.data.cidade
          this.disableCidade = false
          // console.log(response.data.cidade)
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    loadEstado() {
      this.api('/estado')
        .then(response => {
          this.estado = response.data.estado
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
  },
}
</script>
<style scope lang="scss">
.senha {
  color: rgb(40, 57, 211);
}
.senha:hover {
  color: rgb(29, 115, 245);
}

.outline-login .container .v-input .v-input__control .v-input__slot {
  border: 2px solid #005bb9;
}

.logo-form-login.educampo .v-image__image--cover {
  background-size: contain;
  background-position: center !important;
}

.logo-form-login.sebrae .v-image__image--cover {
  background-size: contain;
  background-position: center !important;
}

html {
  overflow: auto;
}

.headline {
  font-family: 'Poppins', sans-serif !important;
}

.display-grid {
  display: grid;
  height: auto !important;
  .flex {
    background-color: white;
    padding: 7px;
    margin-bottom: 70%;
    .v-responsive.v-image {
      margin-top: 6px;
      padding: 0px 0.7px;
    }
  }
}

.apresentacao {
  font-size: 24px;
  font-family: 'Poppins', sans-serif;
}

.layout-login-row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

@media (min-width: 41em) {
  #fundo {
    background-size: auto;
  }
} /* 656px */

@media (min-width: 47em) {
  #fundo {
    background-size: auto;
  }
} /* 752px */

@media (min-width: 68em) {
  #fundo {
    background-size: auto;
  }
} /* 1088px */

@media (min-width: 82em) {
  #fundo {
    background-size: auto;
  }
} /* 1312px */

@media (min-width: 100em) {
  #fundo {
    background-size: contain;
  }
  .layout-logos-login {
    align-items: center !important;
  }
  .tela-login.flex .v-card {
    height: 316px;
  }
  .headline {
    font-size: 34px !important;
  }
  .logo-form-login.educampo {
    height: 110px !important;
  }
  .logo-form-login.sebrae {
    height: 70px !important;
    padding-bottom: 20px;
  }
} /* 1600px */
</style>
